import { Rule } from 'antd/lib/form';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import React, { useEffect, useMemo } from 'react';
import { IItemForGetShortInfo, IGetCustomerLanguages } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getCustomerLanguages } from 'backend/customers';
import { useTranslation } from 'react-i18next';
import { TCreateRestaurantSelectedItem } from '../../../../../createRestaurantState/createRestaurantContext';

interface IDefaultLanguageSelect {
	setIDDefaultLanguage: (value: TCreateRestaurantSelectedItem) => void;
	setFetchedLanguages: (value: IItemForGetShortInfo[]) => void;
	IDSelectedCustomer: TCreateRestaurantSelectedItem;
}

const DefaultLanguageSelect: React.FC<IDefaultLanguageSelect> = ({
	IDSelectedCustomer,
	setIDDefaultLanguage,
	setFetchedLanguages,
}) => {
	const { response, loading, refetch, responseError } = useFetchData<IGetCustomerLanguages, string>(
		IDSelectedCustomer ? getCustomerLanguages : null,
		IDSelectedCustomer || '',
	);
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	useEffect(() => {
		refetch();
	}, [IDSelectedCustomer]);

	useEffect(() => {
		response && setFetchedLanguages(response.data.languages);
	}, [response]);

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectDefaultLanguage') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return (
			response?.data.languages.map((el) => ({
				id: el.id,
				name: tForm(el.name),
			})) || []
		);
	}, [tForm, response]);

	return (
		<FormSelect
			testId="DefaultLanguageSelect"
			name="IDSelectedDefaultLanguage"
			label="defaultLanguageLabel"
			options={mappedOptions}
			fetchError={responseError}
			loading={loading}
			onRefetch={refetch}
			onChange={setIDDefaultLanguage}
			disabled={!IDSelectedCustomer}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(DefaultLanguageSelect);
